import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  // 废弃(原H5商城定制详情)
  {
    path: '/custom',
    name: 'custom',
    component: () => import('./view/custom_order'),
    meta: {
      title: '定制详情'
    }
  },
  // 废弃(智能摩旅大赛活动的排行榜)
  {
    path: '/activities',
    name: 'activities',
    component: () => import('./view/activities_match/index'),
    meta: {
      title: '智慧摩旅大赛'
    }
  },
  // 废弃(智能摩旅大赛活动的中奖名单)
  {
    path: '/result',
    name: 'result',
    component: () => import('./view/activities_match/activity_result'),
    meta: {
      title: '智慧摩旅大赛中奖名单'
    }
  },
  // 废弃(摩征APP旧版本活动详情)
  {
    path: '/hotactivity',
    name: 'hotactivity',
    component: () => import('./view/activity_hot/index'),
    meta: {
      title: '活动详情'
    }
  },
  // 摩征APP H5-积分兑换
  {
    path: '/integral_gift',
    name: 'IntegralGift',
    component: () => import('./view/integral_gift'),
    meta: {
      title: '兑换礼品'
    }
  },
  // 摩征APP H5-积分规则
  {
    path: '/integral_rule',
    name: 'integralRule',
    component: () => import('./view/integral_rule/index'),
    meta: {
      title: '积分规则'
    }
  },
  // 摩征APP H5-排行榜首页
  {
    path: '/rankinglist',
    name: 'rankingList',
    component: () => import('./view/ranking_list/list'),
    meta: {
      title: '排行榜'
    }
  },
  // 摩征APP H5-历史排行榜
  {
    path: '/rankinghistory',
    name: 'rankinghistory',
    component: () => import('./view/ranking_list/history'),
    meta: {
      title: '历史排行榜'
    }
  },
  // 摩征APP H5-排行榜规则
  {
    path: '/rankingrule',
    name: 'rankingrule',
    component: () => import('./view/ranking_list/rule'),
    meta: {
      title: '活动规则'
    }
  },
  // 摩征隐私政策
  {
    path: '/privacy_policy',
    name: 'privacyPolicy',
    component: () => import('./view/privacy_policy/index'),
    meta: {
      title: '摩征隐私政策'
    }
  },
  // 摩征 会员服务协议
  {
    path: '/sales',
    name: 'sales',
    component: () => import('./view/sales/index'),
    meta: {
      title: '会员服务协议'
    }
  },
  // 摩征 会员服务协议
  {
    path: '/webpdf',
    name: 'webpdf',
    component: () => import('./view/webpdf/index'),
    meta: {
      title: '发货单&回执单'
    }
  }
]

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '')
})

const router = new Router({ routes })

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title
  if (title) {
    document.title = title
  }
  next()
})

export {
  router
}
